//import React from 'react';
import { get, BASE_URL } from '../client'; // 위에서 만든 apiClient.js 파일 가져오기
import {DailylookDetail} from '../model/dailylook_detail';

// BASE_URL은 프로젝트 환경에 따라 설정
// const BASE_URL = 'http://52.79.160.172:8001'; 

export const getdailylookDetail = async (id) => {



  try {
    const responseBody = await get(BASE_URL, '/v1/dailylooks/'+id);



    const dailylook = new DailylookDetail(

        responseBody.acc,
        responseBody.average_score,
        responseBody.bottom,
        responseBody.bottom_color,
        responseBody.created_at,
        responseBody.equipments,
        responseBody.hat_color,
        responseBody.id,
        responseBody.image,
        responseBody.introduction,
        responseBody.is_liked,
        responseBody.is_marketing,
        responseBody.more_images,
        responseBody.origin_device_width,
        responseBody.outer,
        responseBody.outerwear_color,

        responseBody.shoes,
        responseBody.shoes_color,
        responseBody.top,
        responseBody.top_color,
        responseBody.user,
        );

            console.log(dailylook)
            return dailylook
    // const dailylooksArray = responseBody.dailylooks.map(item => {
    //     return new Dailylook(
    //     item.created_at,
    //     item.id,
    //     item.image,
    //     item.introduction,
    //     item.more_images,
    //     item.score,
    //     item.thumbnail,
    //     item.user
    //     );
    // });
    // console.log(dailylooksArray[0].thumbnail)

    // return dailylooksArray
    // console.log(dailylooksArray[0].created_at)
    
    // console.log(dailylooksArray[2].more_images[0])
    // console.log(dailylooksArray[3].user.username)
    
    // localStorage.setItem('authToken', responseBody.access_token)
    // const savedToken = localStorage.getItem('authToken');
    // console.log(savedToken)

    // 로그인 성공 후 로직 추가:
    // 예: 토큰 저장, 사용자 정보 상태 업데이트, 페이지 이동 등
    // localStorage.setItem('authToken', responseBody.accessToken);

  } catch (error) {
    console.error('Login failed:', error.message);
    // 에러에 따른 사용자 알림 표시 등
  }
};